import './ServicesO.css';

import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactForm';
import {
  RiCodeBoxLine,
  RiGlobalLine,
  RiSmartphoneLine,
  RiCloudLine,
  RiBrushLine,
  RiShieldKeyholeLine,
  RiBrainLine,
  RiCheckboxCircleLine,
  RiServerLine,
} from 'react-icons/ri';

const services = [
  {
    title: 'AI & Machine Learning',
    icon: <RiBrainLine />,
    path: '/ai',
    features: [
      'Custom LLM integrations',
      'Natural language processing',
      'Image/video recognition',
      'Predictive analytics',
      'AI-driven automation',
    ],
  },
  {
    title: 'Web & Software Development',
    icon: <RiCodeBoxLine />,
    path: '/custom-software',
    features: [
      'Tailored desktop & web applications',
      'Workflow automation',
      'Database-driven tools',
      'Responsive & interactive UIs',
      'Advanced SEO & accessibility',
      'GraphQL & REST APIs',
    ],
  },

  {
    title: 'Mobile App Development',
    icon: <RiSmartphoneLine />,
    path: '/mobile-app',
    features: [
      'Cross-platform solutions',
      'Native app development',
      'Progressive Web Apps (PWA)',
      'Hybrid app development',
      'Push Notifications',
      'App Store Deployment',
    ],
  },
  {
    title: 'Managed IT Services',
    icon: <RiServerLine />,
    path: '/managed-it',
    features: [
      '24/7 Network Monitoring',
      'Proactive Maintenance & Updates',
      'Cybersecurity & Data Backup',
      'Cloud Infrastructure Management',
      'Compliance & Regulatory Support',
    ],


  },

  {
    title: 'Cloud Solutions',
    icon: <RiCloudLine />,
    path: '/cloud',
    features: [
      'Serverless & containerized systems',
      'CI/CD pipelines (GitHub, GitLab)',
      'Multi-cloud deployment (AWS, Azure, GCP)',
      'Infrastructure as Code (Terraform)',
    ],
  },
  {
    title: 'Cybersecurity',
    icon: <RiShieldKeyholeLine />,
    path: '/cybersecurity',
    features: [
      'End-to-end encryption',
      'Threat modeling',
      'Zero-trust architecture',
      'Regular audits & testing',

      'Firewall & Monitoring',
    ],
  },
  {
    title: 'UI/UX Design',
    icon: <RiBrushLine />,
    path: '/services/ui-ux',
    features: [
      'User-first wireframes & flows',
      'Interactive prototypes (Figma)',
      'Design systems & tokens',
      'Accessibility-first layouts',
    ],
  },

];

const Services = () => {
  return (
    <div className="services-container">
      <h2 className="services-title">Our Expert Services</h2>
      <p className="services-description">
        We engineer innovative, scalable, and secure digital solutions—from intelligent AI systems to cloud-native applications—empowering modern businesses with future-ready technology.
      </p>

      <div className="services-grid">
        {services.map((service, index) => (
          <Link to={service.path} key={index} className="service-card">
            <motion.div
              whileHover={{ scale: 1.05 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <ul className="service-list">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <RiCheckboxCircleLine /> {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          </Link>
        ))}
      </div>

      <ContactForm />
    </div>
  );
};

export default Services;